const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const Menu = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	slMenuIcon: '.js-nav-icon',
	slMenuSub: '.sub-menu',
	slMenuItem: '.menu-item-has-children',
	slNavInner: '.js-nav-inner',
	classActive: 'is-active',
	classFixed: 'prevent-scroll',
	classAtRoot: 'is-nav-at-root',
	mobileMax: 989,

	/** @description Initialize */
	init: function() {
		this.mergeMenusOnMobile();
		this.bindEvents();
		$('.site-nav__list > .menu-item').each(function(index) {
			$(this).css('--index', index + 1);
		});

		let resizeTimer;
		Global.$domWindow.on('resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				this.mergeMenusOnMobile();
			}, 250);
		});
	},

	isMobile: function() {
		return window.innerWidth <= this.mobileMax;
	},

	/** @description Merge right navigation into left navigation on mobile */
	mergeMenusOnMobile: function() {
		const $leftList = $('.js-nav-left .site-nav__list');
		const $rightList = $('.js-nav-right .site-nav__list');

		if ($leftList.length && $rightList.length) {
			if (this.isMobile()) {
				if (!$leftList.find('.merged-from-right').length) {
					const $rightItems = $rightList.children('.menu-item').clone();
					$rightItems.addClass('merged-from-right');
					$leftList.append($rightItems);
				}
			} else {
				$leftList.find('.merged-from-right').remove();
			}
		}
	},

	/** @description Bind Events */
	bindEvents: function() {
		$('body').on('click', '.js-menu-btn', this.toggleMenu.bind(this));
		$('body').on('click', '.menu-item-has-children > a', this.handleMenuItemClick.bind(this));
		$('body').on('click', '.js-nav-icon-back a', this.handleBackButton.bind(this));
		Global.escKey(this.closeMenu.bind(this));
		this.clickOutsideContainer();
	},

	toggleMenu: function(e) {
		e.preventDefault();
		const $btn = $(e.currentTarget);

		if (!$btn.hasClass(this.classActive)) {
			$btn.addClass(this.classActive);
			$('.js-nav-outer').addClass(this.classActive);
			Global.$domBody.addClass(this.classFixed);
			this.openCurrentMenuPath();
		} else {
			this.closeMenu();
		}
	},

	/**
	 * Open the submenu branch for the current page (e.g. Listen > Artists).
	 * Skips if user already has a submenu open, or explicitly went back to root.
	 */
	openCurrentMenuPath: function() {
		if (!this.isMobile()) {
			return;
		}

		const $navInner = $('.js-nav-left ' + this.slNavInner);
		if (!$navInner.length || $navInner.hasClass(this.classAtRoot)) {
			return;
		}

		// Already browsing a submenu — keep it
		if ($navInner.find(this.slMenuSub + '.' + this.classActive).length) {
			return;
		}

		const $list = $navInner.find('.site-nav__list').first();
		let $branch = $list.children(
			'.menu-item-has-children.current-menu-ancestor, ' +
			'.menu-item-has-children.current-menu-parent, ' +
			'.menu-item-has-children.current_page_ancestor, ' +
			'.menu-item-has-children.current-menu-item, ' +
			'.menu-item-has-children.current_page_item'
		).first();

		// Fallback: find link matching current URL, then its parent branch
		if (!$branch.length) {
			const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
			$list.find('.sub-menu a[href]').each((_, anchor) => {
				if ($branch.length || $(anchor).closest('.js-nav-icon-back').length) {
					return;
				}
				const href = anchor.getAttribute('href');
				if (!href || href === '#' || href.indexOf('javascript:') === 0) {
					return;
				}
				let linkPath;
				try {
					linkPath = new URL(href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
				} catch {
					return;
				}
				if (linkPath !== '/' && (currentPath === linkPath || currentPath.startsWith(linkPath + '/'))) {
					$branch = $(anchor).closest('.site-nav__list > .menu-item-has-children');
				}
			});
		}

		if (!$branch.length) {
			return;
		}

		// Open full ancestor chain (supports nested submenus)
		const $chain = $branch.add($branch.parents(this.slMenuItem));
		$chain.each((_, el) => {
			const $item = $(el);
			const $submenu = $item.children(this.slMenuSub);
			if ($submenu.length) {
				$item.addClass(this.classActive);
				$submenu.addClass(this.classActive);
			}
		});
	},

	handleMenuItemClick: function(e) {
		const link = $(e.currentTarget);
		const menuItem = link.parent(this.slMenuItem);
		const submenu = link.siblings(this.slMenuSub);

		if (submenu.length > 0) {
			e.preventDefault();
			this.toggleSubMenuForItem(menuItem, submenu);
		}
	},

	handleBackButton: function(e) {
		e.preventDefault();
		const $backBtn = $(e.currentTarget);
		const $submenu = $backBtn.closest(this.slMenuSub);
		const $menuItem = $submenu.parent(this.slMenuItem);
		const $navInner = $backBtn.closest(this.slNavInner);

		$menuItem.removeClass(this.classActive);
		$submenu.removeClass(this.classActive);

		if (!$navInner.find(this.slMenuSub + '.' + this.classActive).length) {
			$navInner.addClass(this.classAtRoot);
		}
	},

	toggleSubMenuForItem: function(menuItem, submenu) {
		const $navInner = menuItem.closest(this.slNavInner);

		if (!menuItem.hasClass(this.classActive)) {
			$navInner.removeClass(this.classAtRoot);

			const $siblings = menuItem.siblings(this.slMenuItem);
			$siblings.removeClass(this.classActive);
			$siblings.find(this.slMenuItem).removeClass(this.classActive);
			$siblings.find(this.slMenuSub).removeClass(this.classActive);

			if (!this.isMobile()) {
				const $otherNavInners = $(this.slNavInner).not($navInner);
				$otherNavInners.find(this.slMenuItem).removeClass(this.classActive);
				$otherNavInners.find(this.slMenuSub).removeClass(this.classActive);
			}

			menuItem.addClass(this.classActive);
			submenu.addClass(this.classActive);
		} else {
			menuItem.removeClass(this.classActive);
			menuItem.find(this.slMenuItem).removeClass(this.classActive);
			submenu.removeClass(this.classActive);
			submenu.find(this.slMenuSub).removeClass(this.classActive);

			if (!$navInner.find(this.slMenuSub + '.' + this.classActive).length) {
				$navInner.addClass(this.classAtRoot);
			}
		}
	},

	clickOutsideContainer: function() {
		Global.$domBody.on('mouseup', (e) => {
			const $menuBtn = $('.js-menu-btn');
			const $menuInner = $(this.slNavInner);
			if (!$menuInner.is(e.target) && $menuInner.has(e.target).length === 0 &&
				!$menuBtn.is(e.target) && $menuBtn.has(e.target).length === 0) {
				this.closeMenu();
			}
		});
	},

	closeMenu: function() {
		$('.js-menu-btn').removeClass(this.classActive);
		$('.js-nav-outer').removeClass(this.classActive);
		Global.$domBody.removeClass(this.classFixed);

		if (!this.isMobile()) {
			$(this.slMenuIcon).removeClass(this.classActive);
			$(this.slMenuItem).removeClass(this.classActive);
			$(this.slMenuSub).removeClass(this.classActive);
			$(this.slNavInner).removeClass(this.classAtRoot);
		}
	}
};

export default Menu;
